<script>
export default {
  name: 'CheckAllGoods'
}
</script>

<script setup>
import { modalUtil } from '@functions/modalUtil.js';
import { computed } from 'vue';

// 外部定義メソッド
const { showModal } = modalUtil();

// emit定義
const emit = defineEmits([
  'updateLoading', 
  'updateCheckedList', 
  'updateAllCheckedList', 
  'clickAddToCart', 
  'switchToDefaultMode',
  'historyAddToCart'
]);

const props = defineProps({
  /**
   * 画面ID
   *    [発注履歴] OrderHistory
   *    [カート] OrderCart
   */
  screenId: {
    type: String,
    required: true
  },
  /**
   * 画面モード
   *     [発注TOP] 通常：default
   *     [カート画面] 通常：default,まとめて削除モード：bulkDelete,納品指定日まとめて編集モード：bulkUpdate
   */
  screenMode: {
    type: String,
    required: false,
    default: 'default'
  },
  // 商品リスト
  goodsList: {
    type: Array,
    required: true
  },
  // チェック済みリスト
  checkedList: {
    type: Array,
    required: true
  },
  // 他ページ込チェック済みリスト
  allCheckedList: {
    type: Array,
    required: true
  }
});

// チェック対象となる商品リスト
const checkableItems = computed(() => {
  if (props.screenId === 'OrderCart') {
    if (props.screenMode === 'bulkUpdate') {
      return props.goodsList.filter(item => item.canOrder !== false && item.canSpecifyDate !== false);
    }
    if (props.screenMode === 'bulkDelete') {
      return props.goodsList;
    }
  }

  return props.goodsList.filter(item => item.canOrder !== false);
});

// チェックボックス変更
const onChangeCheckBox = (event) => {
  const checkedList = [...props.checkedList];
  const allCheckedList = [...props.allCheckedList];
  const keys = checkableItems.value.map(item => props.screenId === 'OrderHistory' ? item.orderInfoId : item.janCode);

  if (event.target.checked) {
    // 全てON
    checkedList.length = 0;
    checkedList.push(...keys);
    const newKeys = keys.filter(key => !allCheckedList.includes(key));
    allCheckedList.push(...newKeys);
  } else {
    // 全てOFF
    checkedList.length = 0;
    const filteredList = allCheckedList.filter(key => !keys.includes(key));
    allCheckedList.length = 0;
    allCheckedList.push(...filteredList);
  }

  // 親のcheckedListを更新
  emit('updateCheckedList', checkedList);
  emit('updateAllCheckedList', allCheckedList);
}

// ページ内でチェック可能な項目数を計算
const checkableItemCount = computed(() => checkableItems.value.length);

const checkCanSpecifyDate = () => {
  // すべて納品指定日指定可能な商品かチェック
  const canSpecifyDate = props.goodsList
    .filter(goods => props.allCheckedList.includes(goods.janCode))
    .every(goods => goods.canSpecifyDate === true);
  if (canSpecifyDate) {
    showModal('deliverySpecifiedDateUpdateModal');
  } else {
    showModal('deliverySpecifiedDateWarningModal');
  }
}

</script>

<template>
  <div class="com_check_all_cnt1">
    <div>
      <div class="com_form_check1 st1">
        <input type="checkbox"
          @change="onChangeCheckBox($event)"
          :indeterminate="props.checkedList.length > 0 && props.checkedList.length < checkableItemCount"
          :checked="checkableItemCount > 0 && props.checkedList.length === checkableItemCount"
          :disabled="checkableItemCount === 0"
        >
        <label>すべて選択</label>
      </div>
      <span v-if="props.checkedList.length === 0" class="com_fs14 com_color1">選択する商品にチェックを入れてください</span>
      <span v-else-if="checkableItemCount > 0 && props.checkedList.length === checkableItemCount" class="com_fs14 com_color1">ページ内 {{ props.checkedList.length }}行 すべて選択中</span>
      <span v-else class="com_fs14 com_color1">ページ内 {{ props.checkedList.length }}行選択中</span>
    </div>
    <div v-if="props.screenId === 'OrderHistory'">
      <button type="button" @click.prevent="emit('historyAddToCart')" class="btn com_btn1" :disabled="props.checkedList.length === 0">カートに追加する</button>
    </div>
    <template v-if="props.screenId === 'OrderCart'">
      <div v-if="props.screenMode === 'bulkUpdate'">
        <button type="button" class="btn com_btn1" :disabled="props.checkedList.length === 0" @click="checkCanSpecifyDate">まとめて編集する<img src="/front/assets/common/img/icon_calender3.png" alt="" class="icon_calender3"></button>
        <button type="button" class="btn com_btn2" @click.prevent="emit('switchToDefaultMode')" data-bs-dismiss="modal">カートに戻る</button>
      </div>
      <div v-else-if="props.screenMode === 'bulkDelete'">
        <button type="button" class="btn com_btn1" :disabled="props.checkedList.length === 0" data-bs-toggle="modal" data-bs-target="#bulkDeleteConfirmModal">まとめて削除する<img src="/front/assets/common/img/icon_trash2.png" alt="" class="icon_trash2"></button>
        <button type="button" class="btn com_btn2" @click.prevent="emit('switchToDefaultMode')" data-bs-dismiss="modal">カートに戻る</button>
      </div>
    </template>
  </div>
</template>
